import { Operators } from "../../../../fetch-xml/filter/Operators";
import { ICondition } from "./ICondition";

export class OptionSetCondition implements ICondition {
    public isValid(record: { value: number | null, formattedValue: string | null }, cond: ComponentFramework.PropertyHelper.DataSetApi.ConditionExpression): boolean {
        const conditionValue = cond.value?.toString().toLowerCase() ?? "";
        const recordFormattedValue = record.formattedValue?.toLowerCase() ?? "";
        const filter = Array.isArray(cond.value) ? null : Number(cond.value);

        switch (cond.conditionOperator) {
            case Operators.Equal.Value: {
                return record.value == filter;
            }
            case Operators.DoesNotEqual.Value: {
                return record.value == null || record.value != filter;
            }
            case Operators.In.Value: {
                const filterNumbers = Array.from(cond.value, Number);
                //+ is for two options
                return record.value != null && filterNumbers.includes(+record.value);
            }
            case Operators.NotIn.Value: {
                const filterNumbers = Array.from(cond.value, Number);
                //+ is for two options
                return record.value == null || !filterNumbers.includes(+record.value);
            }
            case Operators.Like.Value: {
                return recordFormattedValue.includes(conditionValue);
            }
            case Operators.NotLike.Value: {
                return !recordFormattedValue.includes(conditionValue);
            }
            case Operators.BeginsWith.Value: {
                return recordFormattedValue.startsWith(conditionValue);
            }
            case Operators.DoesNotBeginWith.Value: {
                return !recordFormattedValue.startsWith(conditionValue);
            }
            case Operators.EndsWith.Value: {
                return recordFormattedValue.endsWith(conditionValue);
            }
            case Operators.DoesNotEndWith.Value: {
                return !recordFormattedValue.endsWith(conditionValue);
            }
            case Operators.DoesNotContainData.Value: {
                return record.value === null;
            }
            case Operators.ContainsData.Value: {
                return record.value !== null;
            }
        }
        return true;
    }
}
